module.exports = __webpack_public_path__ + "img/nature-vs-humans-album.087ad963.jpg";